function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  opacity: 0.2,
  cx: 20,
  cy: 20,
  r: 20,
  fill: "#4038FF"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15 29V12l14 8.5L15 29z",
  fill: "#4038FF"
});

var SvgIconPlaying = function SvgIconPlaying(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none"
  }, props), _ref, _ref2);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBvcGFjaXR5PSIwLjIiIGN4PSIyMCIgY3k9IjIwIiByPSIyMCIgZmlsbD0iIzQwMzhGRiIvPgo8cGF0aCBkPSJNMTUgMjlWMTJMMjkgMjAuNUwxNSAyOVoiIGZpbGw9IiM0MDM4RkYiLz4KPC9zdmc+Cg==";
export { SvgIconPlaying as ReactComponent };